const url = require('./dev.uri').BASE_URI;

module.exports = {
  [url]: {
    target:'https://tpr.ndlink.cn',
    // target:'https://szfn.tpr.ndlink.cn',
    // target:'https://wfshgz.tpr.ndlink.cn',
    // target:'https://bjtzsg.tpr.ndlink.cn',
    // target:'https://shsw.tpr.ndlink.cn',
    // target:'https://test.tpr.ndlink.cn',
    // target:'http://localhost:48080',
    changeOrigin: true,
      pathRewrite: {
  ['^' + url]: ''
}
}
}
